
export default function SQLs_In() {
  return (
    <div>
      <h1>SQL In</h1>
      <p>Content for SQL In will go here.</p>
    </div>
  );
}
